var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6293_2336)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20,
    width: 50,
    height: 50,
    rx: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0002 44C48.7143 44 50.3899 43.5308 51.8151 42.6518C53.2403 41.7727 54.3512 40.5233 55.0071 39.0615C55.6631 37.5997 55.8347 35.9911 55.5003 34.4393C55.1659 32.8874 54.3405 31.462 53.1284 30.3431C51.9164 29.2243 50.3721 28.4624 48.6909 28.1537C47.0098 27.845 45.2672 28.0035 43.6836 28.609C42.0999 29.2145 40.7464 30.2398 39.7941 31.5554C38.8418 32.871 38.3335 34.4178 38.3335 36C38.3358 38.1211 39.2496 40.1547 40.8744 41.6545C42.4993 43.1544 44.7023 43.9979 47.0002 44ZM47.0002 30.6667C48.1429 30.6667 49.26 30.9795 50.2101 31.5655C51.1603 32.1515 51.9008 32.9845 52.3381 33.959C52.7754 34.9336 52.8899 36.0059 52.6669 37.0405C52.444 38.0751 51.8937 39.0254 51.0857 39.7712C50.2776 40.5171 49.2481 41.0251 48.1274 41.2309C47.0066 41.4366 45.8449 41.331 44.7891 40.9274C43.7334 40.5237 42.831 39.8401 42.1961 38.963C41.5612 38.086 41.2224 37.0548 41.2224 36C41.2224 34.5855 41.8311 33.229 42.9147 32.2288C43.9982 31.2286 45.4678 30.6667 47.0002 30.6667Z",
    fill: "#F3A8A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 46.6672C43.5534 46.6708 40.249 47.9362 37.8118 50.1859C35.3747 52.4355 34.0038 55.4857 34 58.6672C34 59.0209 34.1522 59.36 34.4231 59.61C34.694 59.8601 35.0614 60.0006 35.4444 60.0006C35.8275 60.0006 36.1949 59.8601 36.4658 59.61C36.7367 59.36 36.8889 59.0209 36.8889 58.6672C36.8889 56.1919 37.9542 53.8179 39.8504 52.0676C41.7466 50.3172 44.3184 49.3339 47 49.3339C49.6816 49.3339 52.2534 50.3172 54.1496 52.0676C56.0458 53.8179 57.1111 56.1919 57.1111 58.6672C57.1111 59.0209 57.2633 59.36 57.5342 59.61C57.8051 59.8601 58.1725 60.0006 58.5556 60.0006C58.9386 60.0006 59.306 59.8601 59.5769 59.61C59.8478 59.36 60 59.0209 60 58.6672C59.9962 55.4857 58.6253 52.4355 56.1882 50.1859C53.751 47.9362 50.4466 46.6708 47 46.6672Z",
    fill: "#1B9075"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6293_2336",
    x: 0,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6293_2336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6293_2336",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.da7484e02db28df1b15ba9a7de385784.svg";
export { ForwardRef as ReactComponent };